import script from "./PrivacyPolicyList.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyList.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyList.vue?vue&type=style&index=0&id=026f2357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026f2357"]])

export default __exports__